import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "TIPO DE DOCUMENTO:")
], -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 8,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_15 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_16 = { class: "visualizar" }
const _hoisted_17 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_23 = {
  key: 1,
  style: {"height":"90px","min-height":"90px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_busca_rapida = _resolveComponent("busca-rapida")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_card = _resolveComponent("card")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_collapse, {
      ghost: "",
      class: "ss-accordion",
      activeKey: _ctx.state.activeKey,
      "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.activeKey) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_collapse_panel, {
          key: "1",
          header: "VINCULAR TÍTULOS JÁ LANÇADOS/ANTECIPADOS"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_busca_rapida, {
                  buscaRapida: _ctx.state.buscaFinanceiro.buscaRapida,
                  "onUpdate:buscaRapida": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.buscaFinanceiro.buscaRapida) = $event)),
                  placeholder: "Digite o valor, data ou qualquer informação do título",
                  onBuscarDados: _ctx.buscarTitulos
                }, null, 8, ["buscaRapida", "onBuscarDados"])
              ]),
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_selecionar_tipo_documento_financeiro, {
                  empresas: [_ctx.props.empresa],
                  contasPagar: true,
                  limparSelecao: true,
                  movimentacaoSaidaPagamentosue: true,
                  codigoSelecionado: _ctx.state.buscaFinanceiro.codigoTipoDocumentoFinanceiro,
                  "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.buscaFinanceiro.codigoTipoDocumentoFinanceiro) = $event)),
                  disabled: !_ctx.props.editavel,
                  onChange: _ctx.buscarTitulos
                }, null, 8, ["empresas", "codigoSelecionado", "disabled", "onChange"])
              ])
            ]),
            _createVNode(_component_a_table, {
              loading: _ctx.state.buscandoTitulos,
              id: "resultadoBuscaTitulosRecebimentoFinanceiro",
              columns: _ctx.state.colunasGrade.filter(item => item.visible),
              "data-source": _ctx.state.titulosFinanceiros,
              rowKey: "codigo",
              pagination: false,
              scroll: { y: 200},
              size: "small",
              rowClassName: "ss-table-campos",
              "row-selection": { selectedRowKeys: _ctx.state.idselecionados, onChange: _ctx.mudarSelecao }
            }, {
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, {
                  mensagem: "Nenhum título foi encontrado, efetue uma nova pesquisa.",
                  resultadoPesquisa: true
                })
              ]),
              bodyCell: _withCtx(({ column, record }) => [
                (column.key === 'acoes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Utilizar este título como Pagamento"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "visualizar",
                            onClick: ($event: any) => (_ctx.utilizarTituloFinanceiro(record))
                          }, [
                            _createVNode(_component_icone, { nome: "correto" })
                          ], 8, _hoisted_6)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (column.key === 'NumeroTitulo')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.numeroTitulo), 1))
                    : (column.key === 'TipoDocumentoFinanceiro')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.descricaoTipoDocumentoFinanceiro), 1))
                      : (column.key === 'Vencimento')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1))
                        : (column.key === 'ValorTotal')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal, 2, true)), 1))
                          : (column.key === 'Status')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 5,
                                title: record.descricaoStatus
                              }, _toDisplayString(record.descricaoStatus), 9, _hoisted_11))
                            : (column.key === 'Conta')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 6,
                                  title: record.descricaoConta
                                }, _toDisplayString(record.descricaoConta), 9, _hoisted_12))
                              : (column.key === 'Categoria')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 7,
                                    title: record.nomePlanoContaCategoria
                                  }, _toDisplayString(record.nomePlanoContaCategoria), 9, _hoisted_13))
                                : (column.key === 'TituloFinanceiro')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createElementVNode("span", null, "Título: " + _toDisplayString(record.numeroTitulo), 1),
                                      _createElementVNode("span", null, "Conta: " + _toDisplayString(record.descricaoConta), 1),
                                      _createElementVNode("span", null, "Categoria " + _toDisplayString(record.nomePlanoContaCategoria), 1),
                                      _createElementVNode("span", null, "Vencimento: " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1),
                                      _createElementVNode("span", null, "Valor: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor, 2, true)), 1),
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("a", _hoisted_16, [
                                          _createVNode(_component_icone, { nome: "correto" })
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading", "columns", "data-source", "row-selection"]),
            ((_ctx.state.idselecionados.length > 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_card, {
                      class: "ss-card-alinhado",
                      titulo: "TÍTULOS SELECIONADOS"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("button", {
                              class: "ant-btn ant-btn-secondary ss-tamanho-completo ss-acao-destaque-secundaria",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.adicionarTodosSelecionados && _ctx.adicionarTodosSelecionados(...args)))
                            }, "Confirmar títulos selecionados")
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_totalizador, {
                              titulo: "QUANTIDADES",
                              valor: _ctx.state.quantidadeTitulosSelecionados,
                              casasDecimais: 0
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL TÍTULOS",
                              monetario: true,
                              valor: _ctx.state.totalTitulosSelecionados
                            }, null, 8, ["valor"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, "."))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"])
  ]))
}